import React from 'react';
import cn from 'classnames';
import { useAtom } from 'jotai';
import { chatAgentModeAtom } from 'src/shared/chatPreferences';
import type { ChatAgentMode } from 'src/shared/chatPreferences';
import styles from './AgentModeToggle.module.scss';

const OPTIONS: { mode: ChatAgentMode; label: string; title: string }[] = [
  {
    mode: 'plan',
    label: 'Plan',
    title: 'Plan: the agent shows a plan and waits for your approval before it changes assets or runs an addon',
  },
  {
    mode: 'run',
    label: 'Run',
    title:
      'Run: changes run right away and can be undone. Plans over 25 assets, or that delete fields, still ask first',
  },
];

/**
 * Plan / Run switch next to the send button. Remembered per user
 * (fs.chat.agentMode) and sent to the proxy as context.agentMode.
 */
export const AgentModeToggle: React.FC<{ disabled?: boolean }> = ({ disabled }) => {
  const [mode, setMode] = useAtom(chatAgentModeAtom);

  return (
    <div className={styles.toggle} role="radiogroup" aria-label="Agent mode">
      {OPTIONS.map((opt) => (
        <button
          key={opt.mode}
          type="button"
          role="radio"
          aria-checked={mode === opt.mode}
          title={opt.title}
          disabled={disabled}
          className={cn(
            styles.option,
            mode === opt.mode && (opt.mode === 'run' ? styles.activeRun : styles.activePlan),
          )}
          onClick={() => setMode(opt.mode)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};
